import { render, staticRenderFns } from "./Strut2000-B.vue?vue&type=template&id=32567016"
import script from "./Strut2000-B.vue?vue&type=script&lang=js"
export * from "./Strut2000-B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports